// src/tabs/logements/ChannelMinStayReadOnly.jsx — WAGON R (A′ Dimitri 13/06)
//
// Affichage READ-ONLY des min. séjours PAR CANAL Beds24 (priceRule.minimumStay,
// Channel Manager) — exposé dans 💰 Info FBZ « Tarification générale », sous le
// MinStayDefaultEditor (qui écrit le min. séjour PAR DÉFAUT room.minStay).
//
// AUCUNE écriture par canal — JAMAIS (définitif Dimitri). Source de vérité =
// Beds24 Channel Manager. Calqué sur OtaMultipliersReadOnly : MÊME hook partagé
// useBeds24Multipliers (action beds24_multipliers_read, champ additif
// `channelMinStays` dans la même endpoint que les multiplicateurs (instance de hook distincte → GET distinct, idempotent read-only).
//
// Best-effort silencieux : échec fetch / liste vide → on n'affiche rien (comme
// les multiplicateurs OTA). Règles Beds24 sans minimumStay → déjà omises serveur.

import { DS } from "../../lib/ui";
import { useBeds24Multipliers } from "../../lib/use-beds24-multipliers";

export default function ChannelMinStayReadOnly({ logementId }) {
  const { channelMinStays, loading, error } = useBeds24Multipliers(logementId);

  // Best-effort silencieux : pendant le chargement, sur erreur, ou si aucune
  // règle Beds24 ne porte de min. séjour → on n'affiche rien du tout.
  if (loading || error) return null;
  if (!Array.isArray(channelMinStays) || channelMinStays.length === 0) {
    return null;
  }

  return (
    <div
      data-testid="channel-minstay-readonly"
      style={{ marginTop: 10 }}
    >
      <div
        style={{
          fontSize: 12,
          fontWeight: 700,
          color: DS.navy,
          marginBottom: 6,
        }}
      >
        Min. séjours par canal (Beds24)
      </div>

      <div style={{ display: "grid", gap: 4, marginBottom: 6 }}>
        {channelMinStays.map((c) => {
          const n = Number(c.minimumStay);
          // A3 (WAGON R5) — priorité au libellé canal DÉRIVÉ des canaux Beds24
          // activés (probe 13/06 : noms de règles vides mais channels lisibles),
          // puis nom de règle s'il existe, sinon « priceRule N » brut.
          const label =
            c.channelLabel && String(c.channelLabel).trim()
              ? String(c.channelLabel).trim()
              : c.name && String(c.name).trim()
                ? String(c.name).trim()
                : `priceRule ${c.priceRule}`;
          return (
            <div
              key={c.priceRule}
              style={{
                fontSize: 12,
                color: "#334",
                display: "flex",
                justifyContent: "space-between",
                gap: 8,
              }}
            >
              <span>{label}</span>
              <strong style={{ color: DS.navy }}>
                {n} nuit{n > 1 ? "s" : ""}
              </strong>
            </div>
          );
        })}
      </div>

      <div style={{ fontSize: 11, color: "#667" }}>
        🔒 Géré dans Beds24 (Channel Manager) — lecture seule.{" "}
        {/* A3 — fallback si les canaux ne sont pas dérivables (règles non
            nommées ET sans canal OTA majeur identifiable). */}
        Pour des libellés plus précis, nommez vos règles dans Beds24.
      </div>
    </div>
  );
}
